/**
 * TotalRecords component
 */

// React
import React, { FC } from 'react';

// Libraries
import { Box, Typography } from '@mui/material';

// Interface
interface TotalRecordsProps {
  totalRecords: number;
  currentPage: number;
  recordsPerPage: number;
}

// Component
const TotalRecords: FC<TotalRecordsProps> = ({ totalRecords, currentPage, recordsPerPage }) => {
  const startRecord = totalRecords > 0 ? (currentPage - 1) * recordsPerPage + 1 : 0;
  const endRecord = Math.min(currentPage * recordsPerPage, totalRecords);

  return (
    <Box display="flex" alignItems="end">
      <Typography variant="h5">
        全 {totalRecords} 件中 {startRecord} 件 〜 {endRecord} 件を表示
      </Typography>
    </Box>
  );
};

export default TotalRecords;
